export type ValueOf<T> = T[keyof T];

export const Currency = Object.freeze({
  EUR: 0,
  USD: 1,
  GBP: 2
});

export type CurrencyValues = ValueOf<typeof Currency>;
export type CurrencyKeys = keyof typeof Currency;